import {
    BaseEntity,
    Entity as DecribeEntity,
    Relation,
    RelationList,
} from '@avangard/utils/entity';

import { OnlineStudentPerformanceItemEntityList } from './online-student-performance-item.entity-list';
import { OnlineStudentPerformanceItemEntity } from './online-student-performance-item.entity';

import type { OnlineStudentPerformance } from '@modules/types/graphql';

export type Entity = Partial<OnlineStudentPerformance> | null;

@DecribeEntity('OnlineStudentPerformanceEntity')
class OnlineStudentPerformanceEntity extends BaseEntity {
    @Relation(() => OnlineStudentPerformanceItemEntity)
    course: OnlineStudentPerformanceItemEntity;

    @RelationList(() => OnlineStudentPerformanceItemEntityList)
    courses: OnlineStudentPerformanceItemEntity[];

    @RelationList(() => OnlineStudentPerformanceItemEntityList)
    subjects: OnlineStudentPerformanceItemEntity[];
}

export { OnlineStudentPerformanceEntity };
